import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import mask from '../../../components/_molecules/CurrencyField/assets/mask';
import Button from '../../../components/_atomic/Button/Button';
import './ClientsTable.scss';
import TrashBox from '../../../assets/icons/TrashIcon.svg';
import DeleteUserSuccessModule from '../../../components/_molecules/DeleteUserSuccessModule/DeleteUserSuccessModule';
import Alert from '../../../components/AlertForm/Alert';

class ClientsTable extends Component {
  static propTypes = {
    getAllUsersFull: PropTypes.func.isRequired,
    usersFull: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hasMoreUsersFull: PropTypes.number.isRequired,
    navigateToLogs: PropTypes.func.isRequired,
    navigateToProfile: PropTypes.func.isRequired,
    deleteUser: PropTypes.func.isRequired,
    alertPopup: PropTypes.shape({
      statusAlert: PropTypes.bool.isRequired,
      typeAlert: PropTypes.number.isRequired,
      messageAlert: PropTypes.string.isRequired,
    }).isRequired,
    setAlertStatus: PropTypes.func.isRequired,
  };
  state = {
    deleteUserModal: false,
    selectedUserId: null,
    selectedUserName: null,
    deleteStatus: null,
  };

  componentWillMount() {
    this.props.getAllUsersFull();
  }
  loadUsers = (page) => {
    this.props.getAllUsersFull({ page });
  }
  toggleDeleteUser = (id) => {
    this.toggleDeleteUserModal(false, null, null);
    this.props.deleteUser(id);
  }
  toggleDeleteUserModal = (status, id, name) => {
    if (status === true) {
      this.setState({
        ...this.state,
        deleteUserModal: status,
        selectedUserId: id,
        selectedUserName: name,
      });
    } else if (status === false) {
      this.setState({
        ...this.state,
        deleteUserModal: status,
        selectedUserId: id,
        selectedUserName: name,
      });
    }
  }
  render() {
    const {
      usersFull, hasMoreUsersFull, navigateToLogs, navigateToProfile, alertPopup, setAlertStatus,
    } = this.props;
    const { deleteUserModal, selectedUserId, selectedUserName } = this.state;
    return (
      <div className="clients-table">

        <DeleteUserSuccessModule
          visible={deleteUserModal}
          disableModal={this.toggleDeleteUserModal}
          toggleDeleteUser={this.toggleDeleteUser}
          userId={selectedUserId}
          userName={selectedUserName}
        />

        {alertPopup !== undefined ?
          <Alert
            type={alertPopup.typeAlert}
            message={alertPopup.messageAlert}
            status={alertPopup.statusAlert}
            setAlertStatus={setAlertStatus}
          /> : null
        }

        <div className="ct-table">
          <div className="ct-thead">
            <div className="ct-tr">
              <div className="ct-th">
                <span>Company</span>
              </div>
              <div className="ct-th">
                <span>Name</span>
              </div>
              <div className="ct-th">
                <span>Email</span>
              </div>
              <div className="ct-th">
                <span>Balance</span>
              </div>
              <div className="ct-th">
                <span>Logs</span>
              </div>
              <div className="ct-th">
                <span>Action</span>
              </div>
            </div>
          </div>
          <div className="ct-tbody">
            {usersFull.length ? (
              <InfiniteScroll
                pageStart={0}
                loadMore={this.loadUsers}
                hasMore={hasMoreUsersFull}
                useWindow={false}
                isReset
                threshold={500}
                element="div"
                loader={
                  <div className="loader" key={0}>
                    Loading ...
                  </div>
                }
              >
                {usersFull.map(user => (
                  <div className="ct-tr">
                    <div role="button" tabIndex={0} onFocus={() => {}} onKeyDown={() => {}} onClick={() => navigateToProfile(user.id)} className="ct-tr clickable-td">
                      <div className="ct-tr">
                        <div className="ct-td">
                          <span>{user.profile.company} </span>
                        </div>
                        <div className="ct-td">
                          <span> {user.profile.fullName}</span>{' '}
                        </div>
                        <div className="ct-td">
                          <span> {user.email}  </span>
                        </div>
                        <div className="ct-td">
                          <span> {mask(user.balance.amount)} $ </span>
                        </div>
                      </div>
                    </div>
                    <div className="ct-td">
                      <Button label="View Logs" secondary clickHandler={() => navigateToLogs(user.id)} />
                    </div>
                    <div className="ct-td">
                      <Button label={<img src={TrashBox} alt="" />} secondary clickHandler={() => this.toggleDeleteUserModal(true, user.id, user.profile.fullName)} />
                    </div>
                    {user.unread && <div className="unread-marker" />}
                  </div>))}
              </InfiniteScroll>
            ) : (
              <div className="placeholder-wrapper">
                <span>There is no data yet for this period...</span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ClientsTable;



// WEBPACK FOOTER //
// ./src/containers/ClientsScreen/ClientsTable/ClientsTable.js